import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { isNil } from 'lodash-es';
import { interval, map, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ferris-wheel-educacional-level',
  templateUrl: './ferris-wheel-educacional-level.component.html',
  styleUrls: ['./ferris-wheel-educacional-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FerrisWheelEducacionalLevelComponent implements AfterViewInit, OnDestroy {
  @Input() public levels: any[] = [];

  public activeLevel = 0;

  private _destroy$ = new Subject<void>();

  constructor(private cdref: ChangeDetectorRef) {}

  public ngAfterViewInit() {
    if (this.levels.length > 1) {
      interval(10000)
        .pipe(
          takeUntil(this._destroy$),
          filter(() => !isNil(this.activeLevel)),
          map(() => (this.activeLevel + 1) % this.levels.length),
        )
        .subscribe(this.onToggleActive);
    }
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public isActive(index: number): boolean {
    return this.activeLevel === index;
  }

  public onToggleActive = (index: number) => {
    this.activeLevel = index;
    this.cdref.markForCheck();
  };
}
